import React from 'react';

import { useGetCompanyInfo } from '../../../../hooks';
import { CompanyInfoShadow } from './CompanyShadow';

const CompanyLicenses = () => {
  const companyInfo = useGetCompanyInfo();

  return (
    <>
      <div
        className="pa-acc-info__label"
        data-testid="PlatformAdminUI-AccountInfo-CompanyInfo-CompanyIdLabel"
      >
        COMPANY ID
      </div>
      {companyInfo.isLoading ? (
        <CompanyInfoShadow className="pa-acc-info__text--co" />
      ) : (
        <div
          className="pa-acc-info__text pa-acc-info__text--co"
          data-testid="PlatformAdminUI-AccountInfo-CompanyInfo-CompanyId"
        >
          {companyInfo.data?.company_id ?? companyInfo.data?.companyId}
        </div>
      )}
    </>
  );
};

export default CompanyLicenses;
